import type {
    MediaBackgroundVideoProcessorOptions,
    MediaVideoProcessorOptions,
} from '@yandex-360/telemost-sdk/device-manager';
import {
    MediaImageVideoBackgroundObjectFit,
    MediaVideoBackgroundProcessorType,
} from '@yandex-360/telemost-sdk/device-manager';
import type { BackgroundVideoProcessorOptions, VideoProcessorOptions } from '@yandex-video-platform/goloom-sdk';
import { ImageVideoBackgroundObjectFit, VideoBackgroundProcessorType } from '@yandex-video-platform/goloom-sdk';

const mapImageObjectFitFromGoloom = (
    objectFit: Maybe<ImageVideoBackgroundObjectFit>
): Maybe<MediaImageVideoBackgroundObjectFit> => {
    switch (objectFit) {
        case ImageVideoBackgroundObjectFit.COVER:
            return MediaImageVideoBackgroundObjectFit.COVER;
        case ImageVideoBackgroundObjectFit.FILL:
            return MediaImageVideoBackgroundObjectFit.FILL;
        case undefined:
            return undefined;
        default: {
            const unexpected: never = objectFit;

            return unexpected;
        }
    }
};

const mapImageObjectFitToGoloom = (
    objectFit: Maybe<MediaImageVideoBackgroundObjectFit>
): Maybe<ImageVideoBackgroundObjectFit> => {
    switch (objectFit) {
        case MediaImageVideoBackgroundObjectFit.COVER:
            return ImageVideoBackgroundObjectFit.COVER;
        case MediaImageVideoBackgroundObjectFit.FILL:
            return ImageVideoBackgroundObjectFit.FILL;
        case undefined:
            return undefined;
        default: {
            const unexpected: never = objectFit;

            return unexpected;
        }
    }
};

const mapBackgroundVideoProcessorOptionsFromGoloom = (
    options: BackgroundVideoProcessorOptions
): MediaBackgroundVideoProcessorOptions => {
    switch (options.type) {
        case VideoBackgroundProcessorType.BLUR:
            return {
                type: MediaVideoBackgroundProcessorType.BLUR,
                radius: options.radius,
                distance: options.distance,
            };
        case VideoBackgroundProcessorType.IMAGE:
            return {
                type: MediaVideoBackgroundProcessorType.IMAGE,
                source: options.source,
                objectFit: mapImageObjectFitFromGoloom(options.objectFit),
            };
        default: {
            const unexpected: never = options;

            return unexpected;
        }
    }
};

const mapBackgroundVideoProcessorOptionsToGoloom = (
    options: MediaBackgroundVideoProcessorOptions
): BackgroundVideoProcessorOptions => {
    switch (options.type) {
        case MediaVideoBackgroundProcessorType.BLUR:
            return {
                type: VideoBackgroundProcessorType.BLUR,
                radius: options.radius,
                distance: options.distance,
            };
        case MediaVideoBackgroundProcessorType.IMAGE:
            return {
                type: VideoBackgroundProcessorType.IMAGE,
                source: options.source,
                objectFit: mapImageObjectFitToGoloom(options.objectFit),
            };
        default: {
            const unexpected: never = options;

            return unexpected;
        }
    }
};

export const mapVideoProcessorOptionsFromGoloom = (options: VideoProcessorOptions): MediaVideoProcessorOptions => ({
    backgroundProcessorOptions:
        options.backgroundProcessorOptions === false
            ? false
            : mapBackgroundVideoProcessorOptionsFromGoloom(options.backgroundProcessorOptions),
});

export const mapVideoProcessorToGoloom = (options: MediaVideoProcessorOptions): VideoProcessorOptions => ({
    backgroundProcessorOptions:
        options.backgroundProcessorOptions === false
            ? false
            : mapBackgroundVideoProcessorOptionsToGoloom(options.backgroundProcessorOptions),
});
